/**
 * Query Key factory for all patient note queries.
 *
 * @module PatientNote
 */

import { Pagination } from "@customTypes/index";


export const patientNoteQKeys = {
  all: () => ["patientNotes"] as const,

  allWithFilters: (filters?: {
    patientId: string;
    pagination?: Partial<Pagination>;
    search?: string;
    category?: string;
    tags?: string;
    dateRange?: string;
  }) => [...patientNoteQKeys.all(), { ...filters }] as const,

  singlePatientNote: (patientNoteId: string) =>
    [...patientNoteQKeys.all(), patientNoteId] as const,

  templates: () => [...patientNoteQKeys.all(), "templates"] as const,
  template: (category: string) => [...patientNoteQKeys.templates(), category],

  tags: () => [...patientNoteQKeys.all(), "tags"] as const,
};
